import React from 'react';

// Internal Import

// External Import
import { common } from "@mui/material/colors";
import { useNavigate } from 'react-router-dom';


import { Box, Stack, Typography } from '@mui/material';
import { AppBarComponent } from '../components/appbar';




export interface NotFoundProps { }
export const NotFoundScreen: React.FC<NotFoundProps> = () => {

    let navigate = useNavigate();

    return (
        <Stack>
            <AppBarComponent />
            <Box sx={{
                width: '100vw',
                height: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}>

                <Box sx={{
                    width: '50vw',
                    display: 'flex',
                    alignItems: 'center',
                    flexDirection: 'column',
                }}>
                    <img
                        src="/assets/images/404.png"
                        loading='lazy'
                        style={{ 
                            width: '30vw', 
                            objectFit: 'cover' 
                        }}
                    />
                    <Typography
                        color={common.black}
                        sx={{
                            fontWeight: 'bold',
                            textAlign: 'center',
                            fontFamily: 'Montserrat',
                            textTransform: 'uppercase',
                            fontSize: { xs: 12, sm: 18.5, md: 30 },
                        }}
                    >
                        oops...<br />
                        page not found!
                    </Typography>
                </Box>
            </Box>
        </Stack>
    )
};